/**
 * Efeitos sonoros, portados de docs/prototipo/index.html (bloco "Áudio").
 *
 * São sintetizados com `OscillatorNode` em vez de arquivos: o telão abre sem
 * baixar nada e o som funciona offline. Os valores de frequência e envelope são
 * os do protótipo.
 */

let context: AudioContext | null = null;

function ensureContext(): AudioContext | null {
  if (!context) {
    try {
      context = new (
        window.AudioContext ||
        (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext
      )();
    } catch {
      return null;
    }
  }

  if (context.state === 'suspended') void context.resume();
  return context;
}

function tone(
  frequency: number,
  duration: number,
  type: OscillatorType = 'sine',
  gain = 0.15,
  when = 0,
) {
  const audio = ensureContext();
  if (!audio) return;

  const oscillator = audio.createOscillator();
  const volume = audio.createGain();
  const start = audio.currentTime + when;

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, start);
  volume.gain.setValueAtTime(0, start);
  volume.gain.linearRampToValueAtTime(gain, start + 0.01);
  volume.gain.exponentialRampToValueAtTime(0.0001, start + duration);

  oscillator.connect(volume).connect(audio.destination);
  oscillator.start(start);
  oscillator.stop(start + duration + 0.05);
}

export const sfx = {
  /** Tiquetaque do suspense. */
  tick: () => tone(700 + Math.random() * 500, 0.05, 'square', 0.035),

  /** Revelação da bola. */
  reveal: () => {
    tone(784, 0.5, 'triangle', 0.18);
    tone(1175, 0.7, 'sine', 0.12, 0.07);
  },

  /** Fanfarra da comemoração. */
  fanfare: () => {
    [523, 659, 784, 1047].forEach((frequency, index) =>
      tone(frequency, 0.25, 'triangle', 0.18, index * 0.13),
    );
    [523, 659, 784, 1047].forEach((frequency) => tone(frequency, 1.4, 'sawtooth', 0.05, 0.6));
  },

  /** Bingo não confirmado: duas notas graves descendo. */
  rejected: () => {
    tone(196, 0.45, 'sawtooth', 0.07);
    tone(147, 0.7, 'sawtooth', 0.07, 0.3);
  },
};
